export default "__VITE_ASSET__CwyCEa6p__"